import { defineMessages } from 'react-intl'

export const checkoutInfoMessages = defineMessages({
  title: {
    id: 'payment.checkoutTitle',
    description: 'check out section title',
    defaultMessage: 'Check Out',
  },
  termsAndPolicy: {
    id: 'payment.termsAndPolicy',
    description: 'Privacy Policy and Terms text on checkout page',
    defaultMessage: `By checking this box, I acknowledge that I have read and agree to <termsAndConditions>Savant Subscriptions Terms and Conditions</termsAndConditions> and allow Savant to automatically charge my payment method.`,
  },
  termsAndPolicyNetwork: {
    id: 'payment.termsAndPolicyNetwork',
    description: 'Juniper Privacy Policy and Terms text on checkout page',
    defaultMessage:
      "By configuring and deploying a Savant Smart Network, I agree to <termsAndConditionsJuniper>Juniper Network Inc's Terms of Use</termsAndConditionsJuniper>",
  },
})
